const svgProps = {
	viewBox: '0 0 24 24',
	'aria-hidden': true,
};

export const OccupationIcon = () => (
	<svg {...svgProps}>
		<path d="M9 7V5.8A1.8 1.8 0 0 1 10.8 4h2.4A1.8 1.8 0 0 1 15 5.8V7" />
		<path d="M5 7h14a2 2 0 0 1 2 2v8.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5V9a2 2 0 0 1 2-2Z" />
		<path d="M3 12h18" />
		<path d="M10 12h4" />
	</svg>
);

export const RelationshipIcon = () => (
	<svg {...svgProps}>
		<path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
		<path d="M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
		<path d="M3.5 20v-1.5A4.5 4.5 0 0 1 8 14h0a4.5 4.5 0 0 1 4.5 4.5V20" />
		<path d="M11.5 15.2A4.5 4.5 0 0 1 16 14h0a4.5 4.5 0 0 1 4.5 4.5V20" />
	</svg>
);

export const EthnicityIcon = () => (
	<svg {...svgProps}>
		<circle cx="12" cy="12" r="9" />
		<path d="M3 12h18" />
		<path d="M12 3c2.2 2.4 3.2 5.4 3.2 9s-1 6.6-3.2 9c-2.2-2.4-3.2-5.4-3.2-9S9.8 5.4 12 3Z" />
	</svg>
);

export const AgeIcon = () => (
	<svg {...svgProps}>
		<circle cx="8" cy="8" r="3.5" />
		<circle cx="16" cy="16" r="3.5" />
		<path d="M6.5 8h3" />
		<path d="M8 6.5v3" />
		<path d="M14.8 15h2.4l-2.4 2" />
	</svg>
);

export const BodyTypeIcon = () => (
	<svg {...svgProps}>
		<path d="M8 4c.8 2.2 1.2 4 1.2 5.4 0 1.7-.8 3-1.6 4.2-.7 1.1-1.4 2.2-1.4 3.8V20" />
		<path d="M16 4c-.8 2.2-1.2 4-1.2 5.4 0 1.7.8 3 1.6 4.2.7 1.1 1.4 2.2 1.4 3.8V20" />
		<path d="M8.2 14.5h7.6" />
	</svg>
);

export const ZodiacIcon = () => (
	<svg {...svgProps}>
		<path d="m12 3 1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7L12 3Z" />
		<path d="m18 15 .7 2.3L21 18l-2.3.7L18 21l-.7-2.3L15 18l2.3-.7L18 15Z" />
		<path d="m5.8 16 .5 1.5 1.5.5-1.5.5-.5 1.5-.5-1.5-1.5-.5 1.5-.5.5-1.5Z" />
	</svg>
);

export const KinksIcon = () => (
	<svg {...svgProps}>
		<path d="M12 20.2S4.5 16 4.5 9.8A4.2 4.2 0 0 1 12 7.2a4.2 4.2 0 0 1 7.5 2.6c0 6.2-7.5 10.4-7.5 10.4Z" />
		<path d="m16.5 3 .6 1.9L19 5.5l-1.9.6-.6 1.9-.6-1.9-1.9-.6 1.9-.6.6-1.9Z" />
	</svg>
);

export const CountryIcon = () => (
	<svg {...svgProps}>
		<circle cx="12" cy="12" r="9" />
		<path d="M3 12h18" />
		<path d="M12 3c2.2 2.4 3.2 5.4 3.2 9s-1 6.6-3.2 9c-2.2-2.4-3.2-5.4-3.2-9S9.8 5.4 12 3Z" />
	</svg>
);

export const PROFILE_ATTRIBUTE_ICONS = {
	occupation: OccupationIcon,
	relationship: RelationshipIcon,
	ethnicity: EthnicityIcon,
	country: CountryIcon,
	age: AgeIcon,
	body: BodyTypeIcon,
	zodiac: ZodiacIcon,
	kinks: KinksIcon,
};
